import React from 'react'
import { Select } from 'components/UI/Select/Select'
import { Filters, UnifiedSearchTab } from './constants'

interface UnifiedSearchFiltersProps {
  filters: Filters
  setFilters: React.Dispatch<React.SetStateAction<Filters>>
  sortBy: string
  setSortBy: (sort: string) => void
  categoryOptions: { label: string; value: string }[]
  typeOptions: { label: string; value: string }[]
  sortOptions: { label: string; value: string }[]
  productOptions: { label: string; value: string }[]
  isOppLoading: boolean
  isProductsLoading: boolean
  selectedTab: UnifiedSearchTab
  /** When true, all filters are disabled (e.g., before any search has been performed) */
  disabled?: boolean
}

export function UnifiedSearchFilters({
  filters,
  setFilters,
  sortBy,
  setSortBy,
  categoryOptions,
  typeOptions,
  sortOptions,
  productOptions,
  isOppLoading,
  isProductsLoading,
  selectedTab,
  disabled = false,
}: UnifiedSearchFiltersProps) {
  const isVariantsTab = selectedTab === 'variants'

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center space-x-4">
        {/* Product Filter - only for variants tab */}
        {isVariantsTab && (
          <div className="flex items-center space-x-2">
            <Select
              disabled={isProductsLoading || disabled}
              items={[
                { label: 'All Products', value: 'all' },
                ...productOptions,
              ]}
              selected={filters.product || 'all'}
              onSelect={(value) =>
                setFilters((prev) => ({ ...prev, product: value }))
              }
              buttonLabel="Product"
              buttonSize="md"
              buttonVariant="outline"
              className="w-56 min-w-[14rem]"
            />
          </div>
        )}

        {/* Opp Cat Filter - hide for variants tab */}
        {!isVariantsTab && (
          <div className="flex items-center space-x-2">
            <Select
              disabled={isOppLoading || disabled}
              items={categoryOptions}
              selected={filters.category}
              onSelect={(value) =>
                setFilters((prev) => ({
                  ...prev,
                  category: value,
                  type: 'all', // Reset type when category changes
                }))
              }
              buttonLabel="Category"
              buttonSize="md"
              buttonVariant="outline"
              className="w-56 min-w-[14rem]"
            />
          </div>
        )}

        {/* Type Filter - hide for variants tab */}
        {!isVariantsTab && (
          <div className="flex items-center space-x-2">
            <Select
              disabled={isOppLoading || disabled}
              items={typeOptions}
              selected={filters.type}
              onSelect={(value) =>
                setFilters((prev) => ({ ...prev, type: value }))
              }
              buttonLabel="Type"
              buttonSize="md"
              buttonVariant="outline"
              className="w-56 min-w-[14rem]"
            />
          </div>
        )}
      </div>

      {/* Sort - hide for variants tab */}
      {!isVariantsTab && (
        <div className="flex items-center space-x-2">
          <Select
            disabled={disabled}
            items={sortOptions}
            selected={sortBy}
            onSelect={(value) => setSortBy(value)}
            buttonLabel="Sort"
            buttonSize="md"
            buttonVariant="outline"
            className="w-56 min-w-[14rem]"
          />
        </div>
      )}
    </div>
  )
}
